import Header from "../home/header";
import Blogs from "./blogs";
import Footer from "../home/footer";
const BlogPage = () => {
    return(
        <>
            <Header/>
            <Blogs/>
            <Footer/>
        </>
    )
}
export default BlogPage;
